import React from 'react';
export function Footer() {
  return <footer className="py-12 bg-background border-t border-white/5 text-center" data-id="element-91">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-92">
        <div className="mb-8" data-id="element-93">
          <h3 className="text-2xl font-bold text-white mb-2" data-id="element-94">
            🛡️ ADULTO DE RESCATE™
          </h3>
          <p className="text-gold font-medium mb-2" data-id="element-95">
            El sistema de acompañamiento N°1 para padres de adolescentes de
            Argentina y LATAM.
          </p>
          <p className="text-gray-400" data-id="element-96">
            Porque amar a tu hijo/a no debería costarte todas las noches del
            año.
          </p>
        </div>

        <div className="flex flex-wrap justify-center items-center gap-4 md:gap-8 text-gray-400 text-sm mb-12" data-id="element-97">
          <a href="mailto:soporte@adultoderescate.com" className="hover:text-gold transition-colors" data-id="element-98">
            📧 soporteofiacialfegion@gmail.com
          </a>
          <span className="hidden md:inline text-white/10" data-id="element-99">|</span>
          <a href="#" className="hover:text-gold transition-colors" data-id="element-100">
            📲 @fegion
          </a>
          <span className="hidden md:inline text-white/10" data-id="element-101">|</span>
          <a href="#" className="hover:text-gold transition-colors" data-id="element-102">
            🌐 www.fegion.shop
          </a>
        </div>

        <div className="border-t border-white/5 pt-8" data-id="element-103">
          <p className="text-gray-500 text-sm mb-6" data-id="element-104">
            © Adulto de Rescate 2026 — Todos los derechos reservados. Prohibida
            la reproducción y redistribución sin autorización expresa.
          </p>
          <div className="text-gray-600 text-sm italic space-y-1" data-id="element-105">
            <p data-id="element-106">🛡️ "La adolescencia no espera. Pero tampoco es tarde."</p>
          </div>
        </div>
      </div>
    </footer>;
}